import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, Observable, of, switchMap } from 'rxjs';
import { Action } from '@ngrx/store';
import { FirstShiftHttpService } from '../../http/first-shift/first-shift-http.service';
import {
  FirstShiftAppointmentStatusActions,
  FirstShiftAppointmentStatusAPIActions,
} from '../actions/first-shift-appointment-status.actions';

@Injectable()
export class FirstShiftAppointmentStatusEffects {
  public loadFirstShiftAppointmentStatus$: Observable<Action> = createEffect(
    () =>
      this._actions$.pipe(
        ofType(
          FirstShiftAppointmentStatusActions.loadFirstShiftAppointmentStatus,
        ),
        switchMap(() =>
          this._firstShiftHttpService.attended$.pipe(
            mergeMap((attendedData) =>
              of(
                FirstShiftAppointmentStatusAPIActions.loadedFirstShiftAppointmentStatusSuccessfully(
                  {
                    attendedData,
                  },
                ),
              ),
            ),
            catchError((error) =>
              of(
                FirstShiftAppointmentStatusAPIActions.loadedFirstShiftAppointmentStatusUnsuccessfully(
                  {
                    error,
                  },
                ),
              ),
            ),
          ),
        ),
      ),
  );

  constructor(
    private _actions$: Actions,
    private _firstShiftHttpService: FirstShiftHttpService,
  ) {}
}
